import axios from 'axios';

export default class GrupoListadoDocumentacionDetalleService {

    getGrupoListadoDocumentacionDetalle(info) {            
        const url = process.env.VUE_APP_APIURL + `/api/grupolistadodocumentaciondetalle`;    
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

    updateGrupoListadoDocumentacionDetalle(info){
        const url = process.env.VUE_APP_APIURL + `/api/grupolistadodocumentaciondetalleedicion`;     
        return axios.put(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

    createGrupoListadoDocumentacionDetalle(info){
        const url = process.env.VUE_APP_APIURL + `/api/grupolistadodocumentaciondetallealta`;     
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

    deleteGrupoListadoDocumentacionDetalle(info){
        const url = process.env.VUE_APP_APIURL + `/api/grupolistadodocumentaciondetallebaja`;     
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }
}